import React, { useMemo, useState } from "react";
import Layout from "../../../components/common/Layout";
import { ADMIN_NAV } from "../../../utils/navigation";

import EmployeeSalaryAssignmentToolbar from "../../../components/finance/payroll/employee-salary-assignment/EmployeeSalaryAssignmentToolbar";
import EmployeeSalaryAssignmentTable from "../../../components/finance/payroll/employee-salary-assignment/EmployeeSalaryAssignmentTable";
import EmployeeSalaryAssignmentModal from "../../../components/finance/payroll/employee-salary-assignment/EmployeeSalaryAssignmentModal";

import {
  employeeSalaryAssignments as initialAssignments,
  salaryStructures,
  employees,
} from "../../../data/payrollMockData";

const departments = [
  "Engineering",
  "HR",
  "Finance",
  "Sales",
  "Operations",
];

const designations = [
  "Software Engineer",
  "Senior Software Engineer",
  "HR Executive",
  "Finance Executive",
  "Sales Executive",
];

export default function EmployeeSalaryAssignment() {
  const [assignments, setAssignments] = useState(initialAssignments);

  const [search, setSearch] = useState("");
  const [departmentFilter, setDepartmentFilter] = useState("All");
  const [designationFilter, setDesignationFilter] = useState("All");
  const [statusFilter, setStatusFilter] = useState("All");

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedAssignment, setSelectedAssignment] = useState(null);

  const filteredAssignments = useMemo(() => {
    return assignments.filter((item) => {
      const matchesSearch =
        item.employeeName.toLowerCase().includes(search.toLowerCase()) ||
        item.employeeId.toLowerCase().includes(search.toLowerCase());

      const matchesDepartment =
        departmentFilter === "All" ||
        item.department === departmentFilter;

      const matchesDesignation =
        designationFilter === "All" ||
        item.designation === designationFilter;

      const matchesStatus =
        statusFilter === "All" ||
        item.status === statusFilter;

      return (
        matchesSearch &&
        matchesDepartment &&
        matchesDesignation &&
        matchesStatus
      );
    });
  }, [
    assignments,
    search,
    departmentFilter,
    designationFilter,
    statusFilter,
  ]);

  const handleSave = (data) => {
    if (selectedAssignment) {
      setAssignments((prev) =>
        prev.map((item) =>
          item.id === selectedAssignment.id
            ? { ...selectedAssignment, ...data }
            : item
        )
      );
    } else {
      setAssignments((prev) => [
        ...prev,
        {
          id: Date.now(),
          ...data,
        },
      ]);
    }

    setSelectedAssignment(null);
    setIsModalOpen(false);
  };

  const handleDelete = (id) => {
    if (!window.confirm("Delete this assignment?")) return;

    setAssignments((prev) =>
      prev.filter((item) => item.id !== id)
    );
  };

  return (
    <Layout navItems={ADMIN_NAV}>
      <div className="finance-page">

        <div className="finance-page-header">
          <div>
            <h1>Employee Salary Assignment</h1>
            <p>
              Assign salary structures to employees and manage salary mapping.
            </p>
          </div>
        </div>

        <EmployeeSalaryAssignmentToolbar
          search={search}
          setSearch={setSearch}
          departmentFilter={departmentFilter}
          setDepartmentFilter={setDepartmentFilter}
          designationFilter={designationFilter}
          setDesignationFilter={setDesignationFilter}
          statusFilter={statusFilter}
          setStatusFilter={setStatusFilter}
          departments={departments}
          designations={designations}
          onAdd={() => {
            setSelectedAssignment(null);
            setIsModalOpen(true);
          }}
        />

        <EmployeeSalaryAssignmentTable
          assignments={filteredAssignments}
          onEdit={(assignment) => {
            setSelectedAssignment(assignment);
            setIsModalOpen(true);
          }}
          onDelete={handleDelete}
        />

        <EmployeeSalaryAssignmentModal
          isOpen={isModalOpen}
          onClose={() => {
            setSelectedAssignment(null);
            setIsModalOpen(false);
          }}
          onSave={handleSave}
          initialData={selectedAssignment}
          employees={employees}
          salaryStructures={salaryStructures}
        />

      </div>
    </Layout>
  );
}